import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

// **Async Thunks**
export const authLogin = createAsyncThunk("auth/authLogin", async (item, thunkAPI) => {
  try {
    const data = await AuthService.login(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const superadminLogin = createAsyncThunk("auth/superadminLogin", async (item, thunkAPI) => {
  try {
    const data = await AuthService.adminLogin(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  try {

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return true;
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error.response?.data?.message || error.message
    );
  }
});





export const getRoles = createAsyncThunk("auth/getRoles", async (thunkApi) => {
  try {
    const response = await AuthService.getRoles();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const getProfile = createAsyncThunk("auth/getProfile", async (thunkApi) => {
  try {
    const response = await AuthService.FetchProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const getuserProfile = createAsyncThunk("auth/getuserProfile", async (thunkApi) => {
  try {
    const response = await AuthService.getProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const getDashCount = createAsyncThunk("auth/getDashCount", async (thunkApi) => {
  try {
    const response = await AuthService.getDashCount();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});



export const changePassword = createAsyncThunk("auth/changePassword", async (item, thunkApi) => {
  try {
    const response = await AuthService.changePassword(item);
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});



const initialState = {
  loading: false,
  error: "",
  user: AuthService.getUserDetails() || null,

  roles: [],
  profile: null,
  userProfile: null,
  dashCount: {
    totalStudents: 0,
    totalStaff: 0,
    totalBoys: 0,
    totalGirls: 0,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Login
      .addCase(authLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.user = null;
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(authLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Super Admin Login
      .addCase(superadminLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(superadminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(superadminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Logout
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.roles = [];
        state.profile = null;
        state.userProfile = null;
        state.dashCount = {
          totalStudents: 0,
          totalStaff: 0,
          totalBoys: 0,
          totalGirls: 0,
        };
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Roles
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.data || action.payload;
      })
      .addCase(getRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Admin Profile
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.data || action.payload;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // User Profile
      .addCase(getuserProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getuserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.userProfile = action.payload.data || action.payload;
      })
      .addCase(getuserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Dashboard Counts
      .addCase(getDashCount.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getDashCount.fulfilled, (state, action) => {
        state.loading = false;
        state.dashCount = action.payload.data || action.payload;
      })
      .addCase(getDashCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Change Password
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});


export default authSlice.reducer;
